import React, { Component } from 'react'
import { connect } from 'react-redux'
import { pushNavHistory, restoreComplete } from '../store/actions'
import Submenu from './Components/SubmenuFases'
import LateralTag from './Components/LateralTag'
import FasesContent from './Components/FasesContent'
import Chevron from './Components/Chevron'
import './_styles.scss'
import Device from '../../../devices/device.js'
import store from '../../../store.js'
import Utils from '../../../utils/Utils.js'
import getMatches from '../services/getMatches'
import getCurrentStageCode from '../services/getCurrentStageCode.js'
import { startLiveFeedPoller } from '../services/liveFeedService'
import { getElementByPosition, getAllMatches, getNodeCode, sendMetricSelectContent, getPhase2Config, getSportsLiveFeedMiniPlayerConfig } from '../utils.js'
import { 
  MUNDIAL_2026, 
  ELIMINATION_PHASES, 
  SEMIFINAL, 
  FINAL, 
  TERCER_LUGAR, 
  animationDuration,
  MAIN_MENU,
  FASES_DE_GRUPOS,
  matchInProgress
} from '../constants.js'
import Translator from '../../../requests/apa/Translator.js'

class Partidos extends Component {
  constructor (props) {
    super(props)
    this.state = {
      phases: [],
      activePhase: null,
      focusedPhase: null,
      phaseData: {},
      focusedGroup: null,
      focusedChevron: null,
      animateIn: false,
      animationDirection: 'right',
      nextPhaseMatches: {},
      finalMatches: {},
      thirdPlaceMatches: {},
      liveEventsMap: {},
      liveScoresMap: {},
      lineupsMap: {}
    }

    this._isUnmounted = false
    this.livePollers = {}
    this.liveFeedConfig = getSportsLiveFeedMiniPlayerConfig()

    this.handleGroupChange = this.handleGroupChange.bind(this)
    this.handleChevronFocus = this.handleChevronFocus.bind(this)
    this.handleChevronBlur = this.handleChevronBlur.bind(this)

    this.keys = Device.getDevice().getKeys()
    this.contentEl = null

    // Pollers del live feed: { [matchId]: stopFn }
    this.livePollers = {}
    this.liveFeedConfig = getSportsLiveFeedMiniPlayerConfig()
    
    const code = getNodeCode()
    const metadataValue = Utils.getApaMetadataKey('sports_competition_config', null)
    this.idLeague = metadataValue && metadataValue[code] ? metadataValue[code].leagueId : null
    this.isPhase2Enabled = getPhase2Config()
  }

  // ─── Ciclo de vida ─────────────────────────────────────────────────────────

  componentDidMount = async () => {
    const { pendingRestore } = this.props
    const restoreEntry = pendingRestore && pendingRestore.section === this.props.sectionId
      ? pendingRestore
      : null

    const currentStageCode = this.isPhase2Enabled ? await getCurrentStageCode(this.idLeague) : null
    this.fetchPhases(restoreEntry, currentStageCode)
    localStorage.removeItem('lastFocusPais');
  }

  componentWillUnmount () {
    localStorage.removeItem('lastFocusRecordPartido');
    this._isUnmounted = true
    this.stopAllLivePollers()
    // Si pendingRestore está activo, el desmontaje fue causado por un BACK
    // a otra sección → pushNavHistory limpiaría pendingRestore en el reducer
    // impidiendo que el componente destino restaure su estado
    if (this.props.pendingRestore) return

    const { activePhase, phaseData } = this.state
    const currentData = phaseData[activePhase] || {}
    this.props.pushNavHistory({
      section: this.props.sectionId,
      activePhase,
      activeGroup: currentData.activeGroup || null
    })
  }

  componentDidUpdate (prevProps) {
    const { pendingRestore } = this.props
    if (pendingRestore && pendingRestore !== prevProps.pendingRestore) {
      if (pendingRestore && pendingRestore.section === this.props.sectionId) {
        const phaseId = pendingRestore.activePhase
        if (phaseId && !this.state.phaseData[phaseId]) {
          this.fetchPhaseData(phaseId).then(() => this.applyRestore(pendingRestore))
        } else {
          this.applyRestore(pendingRestore)
        }
      }
    }
  }

  // ─── Métodos de datos (puntos de integración con la API real) ──────────────

  safeParse(str) {
    try {
      return JSON.parse(str)
    } catch (e) {
      return null
    }
  }

  fetchPhases (restoreEntry, currentStageCode) {
    const state = store.getState()
    const { navbar: { nodes = [] } = [] } = state
    const mundialNode = nodes && nodes.find(node => node && node.code === MUNDIAL_2026)
    const mundialChilds = (mundialNode && mundialNode.childs) || []
    
    const phases = mundialChilds.map((child) => {
      const appBehaviour = child.app_behaviour
      const appBehaviourJson = appBehaviour && this.safeParse(appBehaviour)
      const { stage_code = null } = appBehaviourJson

      return {
        id: getElementByPosition(stage_code, 0),
        label: child.text
      }
    })

    const matchedPhase = currentStageCode && phases.find(p => p.id === currentStageCode)
    const firstPhaseId = restoreEntry
      ? restoreEntry.activePhase
      : (matchedPhase ? matchedPhase.id : (phases.length > 0 ? phases[0].id : null))

    this.setState({ phases, activePhase: firstPhaseId }, async () => {
      if (firstPhaseId) await this.fetchPhaseData(firstPhaseId)

      if (restoreEntry) {
        this.applyRestore(restoreEntry)
      } else {
        setTimeout(() => {
          if (!this.contentEl) return
          const target = this.contentEl.querySelector('.partidos__submenu-fases .focusable')
          if (target) target.focus()
        }, 0)
      }
    })
  }

  async fetchPhaseData (phaseId) {
    const newPhaseId = getElementByPosition(phaseId, 0)
    const data = await getMatches(this.idLeague, newPhaseId)
    if (!data) return
    if (this._isUnmounted) return

    // Get next stage matches only for finals stages
    const isEliminationPhase = ELIMINATION_PHASES.includes(newPhaseId)
    
    const nextStageCode = data.navigation && data.navigation.nextStageCode
    const nextPhaseData = nextStageCode && isEliminationPhase ? await getMatches(this.idLeague, nextStageCode) : null
    if (this._isUnmounted) return
    const nextPhaseMatches = nextPhaseData && nextPhaseData.matchesPerGroup
    const nextPhaseMatchesFlatten = getAllMatches(nextPhaseMatches || {})

    const isFinalPhase = newPhaseId === SEMIFINAL || newPhaseId === FINAL
    const isSemifinals = newPhaseId === SEMIFINAL

    //Get final match for semifinals
    const finalData = isSemifinals ? await getMatches(this.idLeague, FINAL) : null
    if (this._isUnmounted) return
    const finalMatches = finalData && finalData.matchesPerGroup
    const finalMatchesFlatten = getAllMatches(finalMatches || {})

    //Get third place for final phases
    const thirdPlaceData = isFinalPhase ? await getMatches(this.idLeague, TERCER_LUGAR) : null
    if (this._isUnmounted) return
    const thirdPlaceMatches = thirdPlaceData && thirdPlaceData.matchesPerGroup
    const thirdPlaceFlatten = getAllMatches(thirdPlaceMatches || {})

    // Guard: si el componente se desmontó durante las requests async, abortar
    if (this._isUnmounted) return

    this.setState(function (prevState) {
      const groups = data.matchesPerGroup && data.activeGroup
        ? data.matchesPerGroup[data.activeGroup] || []
        : []
      
      return {
        phaseData: {
          ...prevState.phaseData, 
          [newPhaseId]: { ...data, groups } 
        },
        nextPhaseMatches: {
          ...prevState.nextPhaseMatches,
          [newPhaseId]: nextPhaseMatchesFlatten
        },
        finalMatches: {
          ...prevState.finalMatches,
          [newPhaseId]: finalMatchesFlatten
        },
        thirdPlaceMatches: {
          ...prevState.thirdPlaceMatches,
          [newPhaseId]: thirdPlaceFlatten
        }
      }
    })

    // Iniciar pollers de live feed para partidos IN_PROGRESS de esta fase
    // Detener pollers anteriores para evitar acumular polling de fases previas
    this.stopAllLivePollers()
    this.setState({ liveEventsMap: {} })
    const allPhaseMatches = getAllMatches(data.matchesPerGroup || {})
    // this.startLiveFeedForMatches(allPhaseMatches)

    // Métricas
    const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
    const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
    const parentTabData = this.state.phases.find(phase => phase.id === this.state.activePhase) || null
    const parentTabLabel = parentTabData && parentTabData.label
    const childTabData = !isFinalPhase && (data.subGroups.find(group => group.id === data.activeGroup) || null)
    const childTabLabel = parentTabData.id === FASES_DE_GRUPOS ? childTabData && childTabData.roundLongName : childTabData && childTabData.label
    sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel)

  }

  // ─── Live feed ─────────────────────────────────────────────────────────────
  stopAllLivePollers () {
    Object.keys(this.livePollers).forEach((id) => {
      if (typeof this.livePollers[id] === 'function') this.livePollers[id]()
    })
    this.livePollers = {}
    if (!this._isUnmounted) this.setState({ liveEventsMap: {}, liveScoresMap: {} })
  }
  startLiveFeedForMatches (matches) {
    // Scenario 4/6: si la config no existe o enabled=false, no arranca
    if (!this.liveFeedConfig || !this.liveFeedConfig.enabled) return

    var flatMatches = []
    ;(Array.isArray(matches) ? matches : []).forEach(function (item) {
      if (item && Array.isArray(item.matches)) {
        item.matches.forEach(function (m) { if (m) flatMatches.push(m) })
      } else if (item) {
        flatMatches.push(item)
      }
    })

    flatMatches.forEach((match) => {
      var matchId = match && (match.id || match.matchId)
      if (!matchId) return
      if (match.status !== matchInProgress) return
      if (this.livePollers[matchId]) return // poller ya activo

      var stopFn = startLiveFeedPoller(
        matchId,
        this.liveFeedConfig,
        // onNewEvents
        (newEvents) => {
          this.setState((prev) => ({
            liveEventsMap: { ...prev.liveEventsMap, [matchId]: (prev.liveEventsMap[matchId] || []).concat(newEvents).slice(-200) }
          }))
        },
        // onScoreUpdate — Scenario 2
        (score) => {
          this.setState((prev) => ({
            liveScoresMap: { ...prev.liveScoresMap, [matchId]: score }
          }))
        },
        // onLineupsEvent
        (lineupsEvent) => {
          if (this._isUnmounted || !this.livePollers[matchId]) return
          var eType = lineupsEvent.eventType || lineupsEvent.type
          var p = lineupsEvent.payload || {}
          this.setState((prev) => {
            var current = prev.lineupsMap[matchId] || {}
            var next = {}
            if (eType === 'LINEUP_CONFIRMED') {
              next = { homeLineup: p.homeLineup, awayLineup: p.awayLineup }
            } else if (eType === 'SUBSTITUTION') {
              // Marcar playerOut en starters y playerIn en substitutes
              var teamId = p.substitutionTeamId
              var updateTeamLineup = function (lineup) {
                if (!lineup || lineup.teamId !== teamId) return lineup
                var outName = p.playerOut && p.playerOut.name
                // Marcar jugador saliente en starters
                var newStarters = (lineup.starters || []).map(function (player) {
                  if (outName && player.name === outName) {
                    return Object.assign({}, player, { playerOut: true, subMinute: p.minute })
                  }
                  return player
                })
                // Marcar jugador entrante en substitutes
                var newSubs = (lineup.substitutes || []).map(function (s) {
                  if (p.playerIn && s.name === p.playerIn.name) {
                    return Object.assign({}, s, { playerIn: true, subMinute: p.minute })
                  }
                  return s
                })
                return Object.assign({}, lineup, {
                  starters: newStarters,
                  substitutes: newSubs
                })
              }
              next = {
                homeLineup: updateTeamLineup(current.homeLineup),
                awayLineup: updateTeamLineup(current.awayLineup)
              }
            }
            return {
              lineupsMap: { ...prev.lineupsMap, [matchId]: Object.assign({}, current, next) }
            }
          })
        },
        // onMatchFinished — Scenario 4
        (finishedId) => {
          if (typeof this.livePollers[finishedId] === 'function') this.livePollers[finishedId]()
          delete this.livePollers[finishedId]
          if (!this._isUnmounted) {
            this.setState((prev) => ({
              liveScoresMap: {
                ...prev.liveScoresMap,
                [finishedId]: Object.assign({}, prev.liveScoresMap[finishedId] || {}, { matchFinished: true })
              }
            }))
          }
        }
      )
      this.livePollers[matchId] = stopFn
    })

    // Detener pollers de partidos que ya no están en el set actual
    var activeIds = flatMatches.reduce(function (acc, m) {
      var id = m && (m.id || m.matchId)
      if (id && m.status === matchInProgress) acc[id] = true
      return acc
    }, {})
    var staleIds = Object.keys(this.livePollers).filter(function (id) { return !activeIds[id] })
    staleIds.forEach((id) => {
      this.livePollers[id]()
      delete this.livePollers[id]
    })
    if (staleIds.length > 0) {
      this.setState((prev) => {
        const liveEventsMap = { ...prev.liveEventsMap }
        const liveScoresMap = { ...prev.liveScoresMap }
        staleIds.forEach((id) => {
          delete liveEventsMap[id]
          delete liveScoresMap[id]
        })
        return { liveEventsMap, liveScoresMap }
      })
    }
  }

  // ─── Handlers ──────────────────────────────────────────────────────────────

  handlePhaseChange =  (steps) => {
    const { phases, activePhase, phaseData } = this.state
    if (!phases.length) return

    const currentData = phaseData[activePhase] || {}

    this.props.pushNavHistory({
      section: 'partidos',
      activePhase,
      activeGroup: currentData.activeGroup || null
    })

    const idx = phases.findIndex(function (p) { return p.id === activePhase })
    const newIdx = ((idx + steps) % phases.length + phases.length) % phases.length
    const newPhaseId = phases[newIdx].id
    const isFinalPhase = newPhaseId === SEMIFINAL || newPhaseId === FINAL

    const direction = steps > 0 ? 'right' : 'left'

    this.setState(prevState => ({
      activePhase: newPhaseId,
      focusedPhase: newPhaseId,
      animateIn: this.isPhase2Enabled ? true : false,
      animationDirection: direction
    }), async () => {
      if (!this.state.phaseData[newPhaseId]) {
        await this.fetchPhaseData(newPhaseId)
      } else {
        // Datos cacheados: reiniciar pollers para la nueva fase
        const cachedData = this.state.phaseData[newPhaseId]
        const cachedMatches = getAllMatches(cachedData.matchesPerGroup || {})
        this.stopAllLivePollers()
        if (!this._isUnmounted) {
          this.startLiveFeedForMatches(cachedMatches)
        }
      }
    })

    // Métricas
    const data = this.state.phaseData[newPhaseId]
    if (data) {
      const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
      const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
      const parentTabData = phases.find(phase => phase.id === newPhaseId) || null
      const parentTabLabel = parentTabData && parentTabData.label
      const childTabData = !isFinalPhase && (data.subGroups.find(group => group.id === data.activeGroup) || null)
      const childTabLabel = parentTabData.id === FASES_DE_GRUPOS ? childTabData && childTabData.roundLongName : childTabData && childTabData.label
      sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel)
    }

    setTimeout(() => {
      this.setState({ animateIn: false })
    }, animationDuration)
  }

 handleGroupChange = (steps) => {
    const { activePhase, phaseData } = this.state
    const currentData = phaseData[activePhase] || {}
    const subGroups = currentData.subGroups || []
    if (!subGroups.length) return

    const idx = subGroups.findIndex(g => g.id === currentData.activeGroup)
    const newIdx = Math.max(0, Math.min(idx + steps, subGroups.length - 1))
    const newGroupId = subGroups[newIdx].id

    //Setea el foco en el chevron correspondiente al exceder el límite de grupos
    if (newGroupId === currentData.activeGroup) {
      if (this.contentEl) {
        const selector = steps < 0
          ? '.mundial2026__chevron--left .focusable'
          : '.mundial2026__chevron--right .focusable'
        const chevronEl = this.contentEl.querySelector(selector)
        if (chevronEl) chevronEl.focus()
      }
      return
    }

    this.props.pushNavHistory({
      section: 'partidos',
      activePhase,
      activeGroup: currentData.activeGroup || null
    })

    const matchesPerGroup = currentData.matchesPerGroup || {}
    const newGroups = matchesPerGroup[newGroupId] || []

    this.setState(prevState => ({
      phaseData: {
        ...prevState.phaseData,
        [activePhase]: { ...currentData, activeGroup: newGroupId, groups: newGroups }
      }
    }))

    // Métricas
    const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
    const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
    const parentTabData = this.state.phases.find(phase => phase.id === activePhase) || null
    const parentTabLabel = parentTabData && parentTabData.label
    const childTabData = subGroups.find(group => group.id === newGroupId) || null
    const childTabLabel = parentTabData.id === FASES_DE_GRUPOS ? childTabData && childTabData.roundLongName : childTabData && childTabData.label
    sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel)
  }


  handleChevronFocus = (direction) => {
    this.setState({ focusedChevron: direction })
  }

  handleChevronBlur = () => {
    this.setState({ focusedChevron: null })
  }

  // Aplica la restauración de estado recibida desde el store de Mundial2026
  // tras un BACK. El historial ya fue actualizado por el padre; aquí sólo
  // se sincroniza el estado local de Partidos y se restaura el foco.
  applyRestore = (entry) => {
    const { activePhase, activeGroup } = entry

    // Se usa la forma funcional de setState para que React garantice que
    // los setState previos de fetchPhaseData ya fueron aplicados antes
    // de que este updater lea prevState.phaseData.
    this.setState(prevState => {
      const targetPhaseData = prevState.phaseData[activePhase] || {}
      const matchesPerGroup = targetPhaseData.matchesPerGroup || {}
      const groups = activeGroup
        ? (matchesPerGroup[activeGroup] || [])
        : (targetPhaseData.groups || [])

      return {
        activePhase,
        focusedPhase: activePhase,
        phaseData: {
          ...prevState.phaseData,
          [activePhase]: { ...(prevState.phaseData[activePhase] || {}), activeGroup, groups }
        }
      }
    }, () => {
      this.props.restoreComplete()

      // Luego de restaurar el estado, posiciona el foco en el elemento correcto
      // (tabs de fases o filtros de grupos) según corresponda:
      setTimeout(() => {
        const contentEl = this.contentEl
        if (!contentEl) return
        const restoredPhaseData = this.state.phaseData[activePhase] || {}
        const hasSubGroups = restoredPhaseData.subGroups && restoredPhaseData.subGroups.length > 0
        const selector = hasSubGroups
          ? '.fases-content__submenu-grupos .focusable'
          : '.partidos__submenu-fases .focusable'
        const target = contentEl.querySelector(selector)
        if (target) {
          target.focus()
        } else {
          const fallback = contentEl.querySelector('.focusable')
          if (fallback) fallback.focus()
        }
      }, 0)
    })
  }

  // ─── Render ────────────────────────────────────────────────────────────────

  render () {
    const { 
      phases, 
      activePhase, 
      phaseData, 
      focusedChevron, 
      nextPhaseMatches, 
      finalMatches, 
      thirdPlaceMatches,
      liveEventsMap,
      liveScoresMap,
      lineupsMap
    } = this.state

    const currentData = phaseData[activePhase] || {}
    const nextMatches = nextPhaseMatches[activePhase] || {}
    const finalMatch = finalMatches[activePhase] || {}
    const thirdPlaceMatch = thirdPlaceMatches[activePhase] || {}

    // Etiquetas laterales calculadas cíclicamente desde el array de fases
    // garantiza que siempre muestren la fase adyacente correcta (incluye wrap Final→Fase de grupos)
    const phaseIdx = phases.findIndex(p => p.id === activePhase)
    const prevPhase = phases.length > 0 ? phases[phaseIdx <= 0 ? phases.length - 1 : phaseIdx - 1] : null
    const nextPhase = phases.length > 0 ? phases[phaseIdx >= phases.length - 1 ? 0 : phaseIdx + 1] : null
    const leftTagText = prevPhase ? prevPhase.label : ''
    const rightTagText = nextPhase ? nextPhase.label : ''
    const leftTagId = prevPhase ? prevPhase.id : ''
    const rightTagId = nextPhase ? nextPhase.id : ''

    const subGroups = currentData.subGroups
    const activeGroup = currentData.activeGroup
    const groups = currentData.groups
    const results = currentData.results
    const navigation = currentData.navigation

    const getChevronNavigation = (side) => {
      const chevronNavigation = {}

      if (subGroups && subGroups.length > 0)
        chevronNavigation["data-sn-up"] = '.fases-content__submenu-grupos .focusable'

      if (side && side === 'right') {
        chevronNavigation["data-sn-right"] = ''
      }

      return chevronNavigation
    }

    const tabNavDown = subGroups && subGroups.length > 0
      ? { 'data-sn-down': '.fases-content__submenu-grupos .focusable' }
      : { 'data-sn-down': `${this.isPhase2Enabled ? '.card-partido, .card-partido-square' : '.partidos__chevron-phase1--right .chevron--focusable'}` }

    // Información del path para métricas
    const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
    const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
    const parentTabData = phases.find(phase => phase.id === activePhase) || null
    const parentTabLabel = parentTabData && parentTabData.label
    const childTabData = subGroups && activeGroup
      ? (subGroups.find(group => group.id === activeGroup) || null)
      : null
    const childTabLabel = parentTabData && parentTabData.id === FASES_DE_GRUPOS
      ? childTabData && childTabData.roundLongName
      : childTabData && childTabData.label

    return (
      <div className='partidos__content' ref={(el) => { this.contentEl = el }}>
          <div className='partidos__submenu-fases'>
            <Submenu
              tabs={phases}
              activeTab={activePhase}
              onNavigate={this.handlePhaseChange}
              itemDataOptions={tabNavDown}
              maxCaracters={19}
              classNames={{
                tab: 'tabs-phases',
                active: 'item-active-not-focused',
              }}
              infinite
            />
        </div>
        
        <div className={`partidos__${this.isPhase2Enabled ? 'chevrones' : 'chevrones-phase1'}`}>
          <div
              className={`partidos__${this.isPhase2Enabled ? 'chevron' : 'chevron-phase1'} partidos__${this.isPhase2Enabled ? 'chevron' : 'chevron-phase1'}--left`}
              onFocus={() => this.handleChevronFocus('left')}
              onBlur={this.handleChevronBlur}
          >
              <Chevron
                direction='left'
                onClick={() => this.handlePhaseChange(-1)}
                isFocused={focusedChevron === 'left'}
                dataOptions={getChevronNavigation('left')}
              />
          </div>
          
          <div
              className={`partidos__${this.isPhase2Enabled ? 'chevron' : 'chevron-phase1'} partidos__${this.isPhase2Enabled ? 'chevron' : 'chevron-phase1'}--right`}
              onFocus={() => this.handleChevronFocus('right')}
              onBlur={this.handleChevronBlur}
          >
              <Chevron
                direction='right'
                onClick={() => this.handlePhaseChange(1)}
                isFocused={focusedChevron === 'right'}
                dataOptions={getChevronNavigation('right')}
              />
          </div>
        </div>
        
        <div className='partidos__panel-row'>
            <div className={'partidos__lateral-tag ' + (this.state.animateIn ? 'animate-lateral-l-' + this.state.animationDirection : '')}>
              <LateralTag
                text={leftTagText || ''}
                phaseId={leftTagId || ''}
                side='left'
              />
            </div>
        
            <div className={'partidos__fases-panel ' + (this.state.animateIn ? 'animate-card-' + this.state.animationDirection : '')}>
                <FasesContent
                  phase={activePhase}
                  nextPhase={nextPhase && nextPhase.id}
                  matches={groups || []}
                  filters={subGroups || []}
                  activeTab={activeGroup}
                  onTabChange={this.handleGroupChange}
                  panelFocused={!!focusedChevron}
                  results={results}
                  navigation={navigation}
                  nextMatches={nextMatches}
                  finalMatch={finalMatch}
                  thirdPlaceMatch={thirdPlaceMatch}
                  liveEventsMap={liveEventsMap}
                  liveScoresMap={liveScoresMap}
                  lineupsMap={lineupsMap}
                  path={{
                    mainMenuLabel,
                    parentTabLabel,
                    childTabLabel
                  }}
                />
            </div>
        
            <div className={'partidos__lateral-tag ' + (this.state.animateIn ? 'animate-lateral-r-' + this.state.animationDirection : '')}>
              <LateralTag
                text={rightTagText || ''}
                phaseId={rightTagId || ''}
                side='right'
              />
            </div>
        </div>
    </div>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    pendingRestore: state.pendingRestore
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    pushNavHistory: function (entry) { dispatch(pushNavHistory(entry)) },
    restoreComplete: function () { dispatch(restoreComplete()) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Partidos)


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Partidos/index.jsx